import React from 'react';
import { getImageUrl } from '../../utils/imageProxy';
import { getThumbnailUrl } from '../../utils/thumbnailFallbacks';

export default function RecentlySaved({ recentItems, onItemClick }) {
  return (
    <div className="bg-white rounded-[22px] p-6" style={{ boxShadow: '0 2px 6px rgba(0,0,0,0.06)' }}>
      <h3 className="text-base font-semibold mb-5 tracking-tight" style={{ color: '#111111' }}>Recently Saved</h3>
      <div className="overflow-x-auto scrollbar-hide -mx-2 px-2">
        <div className="flex gap-3 min-w-max">
          {recentItems.length > 0 ? (
            recentItems.slice(0, 12).map((item, i) => {
              const thumbUrl = getThumbnailUrl(item) || item.thumbnail_url || item.image_url || (item.source_type === 'image' ? item.url : null);
              const proxiedUrl = thumbUrl ? getImageUrl({ image: thumbUrl, thumbnail_url: thumbUrl }) : null;
            
              return (
                <div
                  key={item.id || i}
                  onClick={() => onItemClick(item, i)}
                  className="flex-shrink-0 w-32 h-32 rounded-[20px] overflow-hidden bg-[#F7F7F8] cursor-pointer hover:opacity-90 transition-all hover:scale-105 duration-200"
                  style={{ boxShadow: '0 2px 6px rgba(0,0,0,0.06)' }}
                >
                  {proxiedUrl ? (
                    <img 
                      src={proxiedUrl} 
                      alt="" 
                      className="w-full h-full object-cover"
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.style.backgroundColor = '#F7F7F8';
                      }}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-2xl" style={{ backgroundColor: '#F7F7F8' }}>
                      {item.source_type === 'video' ? '🎥' : item.source_type === 'note' ? '📝' : '📄'}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            Array.from({ length: 12 }).map((_, i) => {
              return (
                <div 
                  key={i} 
                  className="flex-shrink-0 w-32 h-32 rounded-[20px]"
                  style={{ backgroundColor: '#F7F7F8', boxShadow: '0 2px 6px rgba(0,0,0,0.06)' }}
                />
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
